import { fvDateUtc } from '@fv/dates'

import type { AdminLoad } from '@/types/admin-load'

export function canMarkDispatched(load: AdminLoad) {
  if (load.isLegacy) return false
  return load.dispatch?.status !== 'ok' && load.dispatch?.status !== 'pending'
}

export function canRegenerateBOL(load: AdminLoad) {
  if (load.isLegacy) return false
  if (load.pickup.status !== 'ok' && load.pickup.status !== 'pending') {
    return false
  }

  const hasTimedOut = fvDateUtc(load.bookedDate).isBefore(
    fvDateUtc().subtract(5, 'minutes'),
  )

  return load.bol?.status === 'requesting' && hasTimedOut
}

export function canRedispatch(load: AdminLoad) {
  if (load.isLegacy) return false
  if (load.dispatch?.status === 'ok') return true
  if (load.dispatch?.status === 'error' || load.dispatch?.method === 'internal')
    return true
  if (!load.dispatch) {
    return fvDateUtc(load.bookedDate).isBefore(
      fvDateUtc().subtract(5, 'minutes'),
    )
  }

  if (
    load.workflow === 'parcel' &&
    load.dispatch?.status === 'not-requested' &&
    load.dispatch?.bolStatus === 'error'
  ) {
    return true
  }

  return false
}

export function canRedispatchViaEmail(load: AdminLoad) {
  if (load.isLegacy) return false
  if (load.selectedQuote?.mode !== 'truckload') return false
  if (
    !load.spotQuoteRecipients?.some(
      r => r.carrierId === load.selectedQuote?.carrierId,
    )
  ) {
    return false
  }

  return load.dispatch?.status === 'error' && load.dispatch?.method === 'api'
}
